import { createAsyncThunk, createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DirectMessageState {
  error: string;
  loading: 'idle' | 'pending' | 'success' | 'failed';
  active_users: any[];
}

const fetchActiveUsers = createAsyncThunk(
  'directMessages/fetchActiveUsers',
  async (payload: any[]) => {
    try {
      return payload;
    } catch (error) {
      throw new Error(error);
    }
  }
);

interface UpdateUserStatusInterface {
  type: 'online' | 'offline' | string;
  user_id: string;
}

const initialState = { loading: 'idle', active_users: [] } as DirectMessageState;

const activeStatusSlice = createSlice({
  name: 'activeStatus',
  initialState,
  reducers: {
    updateInitialActiveUsers(state, action: PayloadAction<any>) {
      state.active_users = [...action.payload];
    },
    updateUserStatus(state, action: PayloadAction<UpdateUserStatusInterface>) {
      switch (action.payload.type) {
        case 'online':
          state.active_users.push(action.payload.user_id);
          break;
        case 'offline':
          state.active_users = state.active_users.filter(e => e !== action.payload.user_id);
          break;
        default:
          state.active_users = state.active_users.filter(e => e !== action.payload.user_id);
          break;
      }
    },
  },
  extraReducers: builder => {
    builder.addCase(fetchActiveUsers.pending, state => {
      state.loading = 'pending';
    });
    builder.addCase(fetchActiveUsers.fulfilled, (state, action) => {
      state.loading = 'success';
      state.active_users = [...action.payload];
    });
    builder.addCase(fetchActiveUsers.rejected, (state, action) => {
      state.loading = 'failed';
      state.error = action.error.message;
    });
  },
});
const getCurrentState = state => state.active_status;
export const selectActiveUsers = createSelector(getCurrentState, active_status => {
  return active_status.active_users;
});

export const { updateUserStatus, updateInitialActiveUsers } = activeStatusSlice.actions;
export default activeStatusSlice.reducer;
